import Button from "components/base/Button";
import { useState } from "react";

const RiskWatchlistCard = ({ rows }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleRows = showAll ? rows : rows.slice(0, 3);

  return (
    <div className="card">
      <div className="flex items-center justify-between">
        <h5>Risk Watchlist</h5>
        <Button className="text-sky-600" onClick={() => setShowAll(!showAll)}>
          {showAll ? "Show Top 3" : "View All"}
        </Button>
      </div>
      <div className="text-xs opacity-60 mt-1">
        Accounts that need immediate intervention to prevent further loss.
      </div>
      <div className="-mx-2">
        <table className="with-line mt-2">
          <thead>
            <tr>
              <th>Customer</th>
              <th>Risk Signal</th>
              <th>Change</th>
              <th>Next Best Action</th>
            </tr>
          </thead>
          <tbody>
            {visibleRows.map((row) => (
              <tr key={`${row.customer}-${row.signal}`}>
                <td>{row.customer}</td>
                <td>{row.signal}</td>
                <td className="text-red-600">{row.change}</td>
                <td>{row.nextAction}</td>
              </tr>
            ))}
            {visibleRows.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center opacity-60 py-4">
                  No risk watchlist items.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RiskWatchlistCard;
